module.exports = [
	{
		"hook": "It's hard to describe just how much of a gamechanger Storytape is for filmmaking.",
		"more": "The time and money I save are alone worth it, but Storytape offers some of the highest quality footage I've seen. Better than anything I could film myself and in locations I could never visit. I'm blown away by how amazing this service is.",
		"author": "JOSH BISSEL"
	},
	{
		"hook": "It's clear the team at Storytape has filmed each clip with purpose.",
		"more": "Being a subscriber to Storytape is like having a high-end production team at your finger tips, and all for less than the price of one clip at other stock video sites.",
		"author": "KARTAL ALYUZ"
	},
	{
		"hook": "Storytape is incredible! Not only does it save money, but it is HUGELY helpful",
		"more": "because individual clips are grouped together in Scenes. I can get as many clips as I want from a specific Scene, and it looks phenomenal! Couldn't be happier!",
		"author": "KATIE WINTON"
	},
	{
		"hook": "Storytape is revolutionizing the stock video industry with its beautifully crafted footage",
		"more": "available at a preposterously affordable price point. There is nothing currently like this anywhere (I've looked) that matches the cinematography and attention to detail, without costing an arm and a leg.",
		"author": "BART ANESTIN"
	},
	{
		"hook": "I always struggled with finding stock video clips that fit within our budget. But with Storytape,",
		"more": "I now have unlimited access to thousands of video clips for the same price as just one clip from other websites.",
		"author": "RYAN NEARHOOD"
	},
	{
		"hook": "I’m a father of six that works two jobs. I was able to produce my first video in less than an hour as I waited for our garage door spring to be replaced.",
		"more": "I have no idea how much time and effort this would have taken without Storytape. To say this changes the game for people like me is an understatement.",
		"author": "ROBERT, Storytape Customer"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/assets/testimonials.json
// module id = 1278
// module chunks = 1 4